import { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { createComponents } from './markdown-components';
import { type TableData } from '../markdown-table/lib';

const remarkPlugins = [remarkGfm];

export type MarkdownProps = {
  children: string;
  className?: string;
  onExpandTable?: (tableData: TableData) => void;
  messageUuid?: string;
  prefix?: string;
};

function NonMemoizedMarkdown({ children, className, onExpandTable, messageUuid, prefix }: MarkdownProps) {
  return (
    <ReactMarkdown
      remarkPlugins={remarkPlugins}
      components={createComponents(messageUuid, onExpandTable, prefix)}
      className={className}
    >
      {children}
    </ReactMarkdown>
  );
}

export const Markdown = memo(NonMemoizedMarkdown, (prevProps, nextProps) => prevProps.children === nextProps.children);
